// extracted by mini-css-extract-plugin
export var button = "_da-7";
export var buttonRow = "_da-6";
export var fadeIn = "_da-1";
export var gradient = "_da-0";
export var panel = "_da-2";
export var panelIn = "_da-3";
export var subtitle = "_da-5";
export var title = "_da-4";